export const RECOVER_PASSWORD = "RECOVER_PASSWORD";
export const RECOVER_PASSWORD_SUCCESSFULL = "RECOVER_PASSSWORD_SUCCESSFULL";
export const RECOVER_PASSWORD_FAILED = "RECOVER_PASSWORD_FAILED"; 